var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#4884e8",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.594 1.842c-.253-.156-.569-.17-.834-.038l-5.617 2.81V2.57C17.143 1.151 15.992 0 14.57 0h-12C1.151 0 0 1.151 0 2.571v10.286c0 1.42 1.151 2.572 2.571 2.572h12c1.42 0 2.572-1.152 2.572-2.572v-2.042l5.617 2.814c.423.211.938.04 1.15-.384.06-.12.09-.253.09-.388V2.571c0-.297-.154-.573-.406-.729zm-8.165 11.015c0 .474-.384.857-.858.857h-12c-.473 0-.857-.383-.857-.857V2.571c0-.473.384-.857.857-.857h12c.474 0 .858.384.858.857v10.286zm6.857-1.387L17.143 8.9v-2.37l5.143-2.57v7.511z",
    transform: "translate(-676.000000, -3742.000000) translate(676.000000, 3742.000000) translate(4.000000, 8.000000)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.82cef38c.svg";
export { ForwardRef as ReactComponent };